export default __webpack_public_path__ + "static/media/robot1.7a7ca868.png";